@for (step of steps; track step; let index = $index; let first = $first) {
<button
  class="btn d-block rounded-circle bg-light"
  [class.bg-dark]="index === currentIndex"
  [class.ml-2]="!first"
  (click)="indicatorChanged.emit(index)"
></button>
}
